import React from "react";
import { Outlet } from "react-router-dom";

const DeficienciesPage: React.FC = () => {
  return (
    <div data-testid="deficiencies">
      <Outlet />
    </div>
  );
};

export default DeficienciesPage;
